<template>
    <Spinner v-if="userStore.isLoading"/>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--login">

            <section class="l-content-area">
                <div class="l-content">

                    <section class="p-bloc p-bloc--register">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">

                                <div class="login-box">

                                    <div class="p-login__title">
                                        <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                                        <h1>{{ $t('LABEL_REGISTER_ACCOUNT') }}</h1>
                                    </div>

                                    <!-- register -->
                                    <section class="p-register c-register-parts">
                                        <p>{{ $t('TEXT_EDIT_ACCOUNT_CONFIRM_1') }}</p>

                                        <form>
                                            <div class="p-register__form p-register__form--confirm">
                                                <dl class="mailaddress">
                                                    <dt>{{ $t('LABEL_EMAIL') }}</dt>
                                                    <dd>
                                                        <p>{{ sessionStore.session_data['email'] }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="region">
                                                    <dt>{{ $t('LABEL_REGION') }}</dt>
                                                    <dd>
                                                        <p>{{ !userStore.isOverseasUser ? $t('LABEL_JAPAN') : $t('LABEL_OVERSEAS') }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="name" v-if="!userStore.isOverseasUser">
                                                    <dt>{{ $t('LABEL_NAME') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ userStore.editAccountParams.last_name }} &nbsp; {{ userStore.editAccountParams.first_name }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="kana" v-if="!userStore.isOverseasUser">
                                                    <dt>{{ $t('LABEL_FURIGANA') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ userStore.editAccountParams.last_name_kana }} &nbsp; {{ userStore.editAccountParams.first_name_kana }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="name" v-if="userStore.isOverseasUser">
                                                    <dt>{{ $t('LABEL_NAME') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ userStore.editAccountParams.full_name }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="birth">
                                                    <dt>{{ $t('LABEL_BIRTHDATE') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ userStore.editAccountParams.birthday }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="sex">
                                                    <dt>{{ $t('LABEL_GENDER') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ GENDER_LIST[userStore.editAccountParams.sex] }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="telephone">
                                                    <dt>{{ $t("LABEL_PHONE_NUMBER") }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ userStore.editAccountParams.tel }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="country" v-if="userStore.isOverseasUser">
                                                    <dt>{{ $t("LABEL_COUNTRY") }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>
                                                        {{
                                                            userStore.countries.find(
                                                            c => c.id === userStore.editAccountParams.country
                                                            )?.name
                                                        }}
                                                        </p>
                                                    </dd>
                                                </dl>

                                                <dl class="zipcode">
                                                    <dt>{{ $t('LABEL_ZIP_CODE') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ userStore.editAccountParams.zip_code }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="address1" v-if="!userStore.isOverseasUser">
                                                    <dt>{{ $t('LABEL_ADDRESS_1') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ PREFECTURES_JA[userStore.editAccountParams.address_1] }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="address2">
                                                    <dt>{{ $t('LABEL_ADDRESS_2') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ userStore.editAccountParams.address_2 }}</p>
                                                    </dd>
                                                </dl>

                                                <dl class="address3">
                                                    <dt>{{ $t('LABEL_ADDRESS_3') }}<span>{{ $t('LABEL_REQUIRED') }}</span></dt>
                                                    <dd>
                                                        <p>{{ userStore.editAccountParams.address_3 }}</p>
                                                    </dd>
                                                </dl>
                                            </div>

                                            <div class="p-register__btn">
                                                <div class="c-btn c-btn--regist-next"><input type="button" :value="$t('LABEL_BUTTON_REGISTER_THIS_CONTENT')" @click="userStore.editAccountConfirm()"></div>
                                            </div>

                                            <div class="p-register__back">

                                                <router-link :to="{ name: 'edit.account' }">
                                                    <div class="c-btn c-btn--regist-back"><button>{{ $t('LABEL_CANCEL') }}</button></div>
                                                </router-link>

                                            </div>
                                        </form>
                                    </section><!-- .p-register -->

                                </div><!-- .bg-box -->

                            </div>
                        </div>
                    </section>


                </div><!-- .l-content -->
            </section><!-- .l-content-area -->

        </div><!-- .l-project-wrap -->

        <!-- footer -->

    </div>
</template>

<script setup>
import {useSessionStore} from "@/stores/sessionStore";
import {useUserStore} from "@/stores/userStore";
import {GENDER_LIST, PREFECTURES_JA} from "@/data/constants";
import Spinner from "@/components/Spinner.vue";

const sessionStore = useSessionStore();
const userStore = useUserStore();
</script>